import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadIpmaCisBarCreator } from 'store/actionsCreators';
import { useTranslation } from 'react-i18next';
import { useSubRoutes, useExactRedirect, usePermissionTabs } from 'hooks';
import { globalPropTypes } from 'helpers';
import { Alerts, Row, Col } from 'components';
import CisTabs from 'components/CisTabs/CisTabs';
import CisHeader from 'components/CisHeader/CisHeader';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.ipma.cisCvmb',
    url: '/ipma/cvmb-cis',
  },
];

const initialTabs = [
  {
    title: 'navigation.tabs.user.cis.reports',
    path: '/ipma/cvmb-cis/reports',
    key: 'cvmb-reports',
  },
  {
    title: 'navigation.tabs.user.cis.statistics',
    path: '/ipma/cvmb-cis/statistics',
    key: 'cvmb-statistics',
  },
  {
    title: 'navigation.tabs.user.cis.certificationBodies',
    path: '/ipma/cvmb-cis/certification-bodies',
    key: 'cvmb-certification-bodies',
  },
];

const Cis = ({ routes, loadBar, bar, userPermissions }) => {
  const { t } = useTranslation();

  const [renderSubRoutes] = useSubRoutes(routes);
  const [tabs, firstTabPath] = usePermissionTabs(initialTabs, routes, userPermissions, bar);
  const [renderExactRedirect] = useExactRedirect('/ipma/cvmb-cis', firstTabPath);

  return (
    <>
      <CisHeader
        breadcrumbs={breadcrumbs}
        title={t('page.ipma.cis.titleCvmb')}
        renderActions={() => (
          <>
            <Row style={{ justifyContent: 'flex-end', alignItems: 'center' }}>
              <Col size={{ xs: 2 / 3 }}>
                <div id="ipma-cis-cvmb-statistics-actions-portal"></div>
              </Col>
              <Col size={{ xs: 1 / 3 }}>
                <div id="ipma-cis-cvmb-statistics-dropdown-portal"></div>
              </Col>
            </Row>
            <Row style={{ justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
              <Col size={{ xs: 1 / 1 }}>
                <div id="ipma-cis-buttons-portal"></div>
              </Col>
            </Row>
          </>
        )}
      />
      <CisTabs disableCounter={true} items={tabs} />
      <Alerts type="cis" />
      {renderExactRedirect()}
      {renderSubRoutes()}
    </>
  );
};

Cis.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  userPermissions: globalPropTypes.UserPermissions.isRequired,
  bar: PropTypes.shape({
    certificationBodies: PropTypes.number,
    cetificateHolders: PropTypes.number,
    certificates: PropTypes.number,
    levelDomains: PropTypes.number,
    invoices: PropTypes.number,
    agreements: PropTypes.number,
    organizations: PropTypes.number,
    reports: PropTypes.number,
  }).isRequired,
};

Cis.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ ipma, user }) => ({
  bar: ipma.cis.bar,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadBar: () => dispatch(loadIpmaCisBarCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cis);
